import imag from "../imagenes/WIN.jpg"
import img2 from "../imagenes/hotel.jpg"
import img3 from "../imagenes/web.jpg"
import img4 from "../imagenes/f.jpg";
import img5 from "../imagenes/ISO.jpg"
import img6 from "../imagenes/reac.jpg"

const Portfolio_data = [
    {
      id: 1,
      category: "3D Maze",
      totalLike: "60",
      title: "3D maze made in Python ",
      imagen: imag,
      texto: "The 3D maze is a video game designed to extract the exploration skills of children and  young people in a three-dimensional environment. The main objective of this video game       is to collect the patterns that the players make when solving the maze. This video game is       made in the Python programming language because it is a versatile language with which       you can create all kinds of applications." ,
      link:'https://github.com/Carlos-An20/3DMaze-Python.git'
    },
    {
      id: 2,
      category: "Hotel Website",
      totalLike: "750",
      title: "Website of a hotel located in Playas - Ecuador",
      imagen: img2,
      texto:"This Web page was developed for a hotel located in the city of Playas-Ecuador. This application shows the rooms, contacts and you can reserve rooms.",
      link:'https://github.com/Carlos-An20/PageWebHotelVistaalMar.git'

    },
    {
      id: 3,
      category: "Me Porfolio",
      totalLike: "630",
      title: "Development of my web portfolio ",
      imagen: img3,
      texto:"This web page is developed in React, the objective is to show all my programming knowledge, in the same way you show my projects and experiences as a software developer.",
      link:'https://github.com/Carlos-An20/MyWebside.git'
    },
    {
      id: 4,
      category: "Simple-Harmonic-Motion-whit-Python ",
      totalLike: "630",
      title: "Calculations based on Simple Harmonic Motion UTA ",
      imagen: img4,
      texto:"This app is developed to calculate the simple harmonic motion. It is made in the python language due to customer requirements.",
      link:'https://github.com/Carlos-An20/Simple-Harmonic-Motion-whit-Python.git'
    },
    {
      id: 5,
      category: "CalculoISO-Python",
      totalLike: "630",
      title: "Tolerance calculation and adjustments",
      imagen: img5,
      texto:"This project calculates the tolerance and adjustment of mechanical parts according to its standard. It is made in python, the libraries used are Tkinter for the graphical interface.",
      link:'https://github.com/Carlos-An20/CalculoISO-Python.git'
    },
    {
      id: 6,
      category: "Tareas-React",
      totalLike: "630",
      title: "Schedule tasks",
      imagen: img6,
      texto:"This work is designed in react in order to show my skills in JavaScript.",
      link:'https://github.com/Carlos-An20/Schedule-tasks.git'
    },
  ]
  export default Portfolio_data